import type { IconProps } from '@/types/general'

export const Info = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="15"
    height="16"
    viewBox="0 0 15 16"
    fill="currentColor"
    className={props.className}
  >
    <g clipPath="url(#clip0_8_5540)">
      <path
        d="M7.5 0.502808C3.3645 0.502808 0 3.86731 0 8.00281C0 12.1383 3.3645 15.5028 7.5 15.5028C11.6355 15.5028 15 12.1383 15 8.00281C15 3.86731 11.6355 0.502808 7.5 0.502808ZM8.0625 11.5653C8.0625 11.8758 7.8105 12.1278 7.5 12.1278C7.1895 12.1278 6.9375 11.8758 6.9375 11.5653V7.44031C6.9375 7.12981 7.1895 6.87781 7.5 6.87781C7.8105 6.87781 8.0625 7.12981 8.0625 7.44031V11.5653ZM7.5 5.75281C7.08563 5.75281 6.75 5.41718 6.75 5.00281C6.75 4.58843 7.08563 4.25281 7.5 4.25281C7.91437 4.25281 8.25 4.58843 8.25 5.00281C8.25 5.41718 7.91437 5.75281 7.5 5.75281Z"
        fill="currentColor"
      />
    </g>
    <defs>
      {/* biome-ignore lint/correctness/useUniqueElementIds: SVG clipPath ID is scoped to this component */}
      <clipPath id="clip0_8_5540">
        <rect width="15" height="15" fill="white" transform="translate(0 0.502808)" />
      </clipPath>
    </defs>
  </svg>
)
